import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  PoLookupFilter,
  PoLookupFilteredItemsParams
} from '@po-ui/ng-components';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICompanyAPI } from '../../interfaces/company.model';

@Injectable({
    providedIn: 'root'
})
export class CompanyService implements PoLookupFilter {
    public company: string;
    protected url: string;

    constructor(private http: HttpClient) {
        this.url = `${environment.url}api/framework/environment/v1/companies`;
    }

    getFilteredItems(
        filteredParams: PoLookupFilteredItemsParams
    ): Observable<ICompanyAPI> {
        const params = {
            corporateName: filteredParams.filter,
            page: filteredParams.page,
            pageSize: filteredParams.pageSize
        };
        return this.http.get<ICompanyAPI>(this.url, { params });
    }

    getObjectByValue(value: string): Observable<ICompanyAPI> {
        return this.http.get<ICompanyAPI>(`${this.url}/${value}`);
    }

    getCompanyFromStorage(): string {
        return localStorage.getItem('company');
    }

    setCompanyToStorage(company: string): void {
        localStorage.setItem('company', company);
    }

    cleanStorageCompany(): void {
        localStorage.removeItem('company');
    }
}
